import { Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { LanguageService } from '../../../services/i18n/language';

interface RoleOption {
  key: 'cargoOwner' | 'freightForwarder' | 'supplier';
  route: string;
}

/** Окно выбора роли перед регистрацией: каждая роль ведёт на свою форму. */
@Component({
  selector: 'app-role-picker',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './role-picker.component.html',
  styleUrl: './role-picker.component.scss'
})
export class RolePickerComponent implements OnInit, OnDestroy {
  @Output() closed = new EventEmitter<void>();

  readonly roles: RoleOption[] = [
    { key: 'cargoOwner', route: '/registration/cargo-owner' },
    { key: 'freightForwarder', route: '/registration/freight-forwarder' },
    { key: 'supplier', route: '/registration/supplier' }
  ];

  private readonly fallback: Record<string, string> = {
    'home.cargoOwner.title': 'Грузовладелец',
    'home.cargoOwner.subtitle': 'Для импортеров и компаний',
    'home.freightForwarder.title': 'Экспедитор грузов',
    'home.freightForwarder.subtitle': 'Для логистических компаний',
    'home.supplier.title': 'Поставщик',
    'home.supplier.subtitle': 'Для производителей и продавцов товара',
    'login.rolePicker.title': 'Выберите роль',
    'login.rolePicker.subtitle': 'Как вы будете работать в Bilload?',
    'login.rolePicker.close': 'Закрыть'
  };

  private subscription?: Subscription;

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscription = this.languageService.getTranslations().subscribe(() => this.cdr.markForCheck());
    document.body.style.overflow = 'hidden';
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  close(): void {
    this.closed.emit();
  }

  t(key: string): string {
    const value = this.languageService.translate(key);
    return !value || value === key ? this.fallback[key] ?? '' : value;
  }
}
